module.exports = __webpack_public_path__ + "img/bonhomme-bleu.c3d6edf9.png";